import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Handles the return from Emergent Google OAuth. The user lands at
// <origin>/app/dashboard#session_id=<sid>; we exchange it for the app JWT.
export default function AuthCallback() {
  const { applySession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    // Clear the fragment immediately so it isn't reused.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sid) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        applySession(data.token, data.user);
        toast.success(
          data.is_new ? `Welcome, ${data.user.name} — $100 bonus added` : `Welcome back, ${data.user.name}`,
        );
        nav(data.user.is_admin ? "/app/admin" : "/app/dashboard", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-neo-bg text-neutral-400 font-mono text-xs uppercase tracking-widest"
      data-testid="auth-callback"
    >
      Signing you in…
    </div>
  );
}
